<template>
  <section
    class="component-f7d0bf1d"
    resmed-component-name="info_icon-line_text_list_cta"
    v-bind:style="{
      'background-color': acf.layout['background-color'],
      'padding-top': acf.layout['padding-top'],
      'padding-bottom': acf.layout['padding-bottom'],
    }"
  >
    <div
      class="component"
      v-bind:class="{
        [`text-${acf.layout['text-align']}`]: true,
        [`text-color-${acf.layout['text-color']}`]: true,
      }"
    >
      <div class="container px-xs-sm-2">
        <div class="row">
          <div class="col-lg-10 offset-lg-1">
            <eyebrow-icon
              v-if="acf.eyebrowicon"
              v-bind:eyebrowicon="acf.eyebrowicon"
              v-bind:align="
                acf.layout['text-align'] === 'center' ? 'center' : ''
              "
            ></eyebrow-icon>
            <h2 class="heading-lg" v-if="acf.headline">{{ acf.headline }}</h2>
            <div class="content" v-html="acf.content"></div>

            <div class="call-to-action mt-4" v-if="acf.cta.href">
              <a
                v-bind:href="acf.cta.href"
                v-bind:target="acf.cta.target"
                class="ctaButton cta-pill filled-red icon right-arrow"
                >{{ acf.cta.text }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "component-f7d0bf1d", // info_icon-line_text_list_cta
  props: ["acf"],
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-f7d0bf1d {
  padding: 4rem 0 3rem 0;

  .component {
    &.text-center {
      h2 {
        @extend %eyebrow-center;
      }
    }

    &.text-color-white {
      h2 {
        &:before {
          background-color: $cc-resmed-white;
        }
      }
    }

    h2 {
      position: relative;
      margin: 0 0 1.75rem 0;

      @extend %eyebrow-left;
    }

    h3,
    h4 {
      margin: 3rem 0 1rem 0;
    }
  }
}
</style>

<style lang="scss">
.component-f7d0bf1d {
  .component {
    ul,
    ol {
      padding-left: 2.325rem;
      margin: 1rem 0;

      li > ul,
      li > ol {
        margin: 0.5rem 0;
      }
    }
  }
}
</style>